export default "__VITE_ASSET__Bqr07UFD__"